var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "sales-links-ul" },
      _vm._l(_vm.salesLinks, function(item, index) {
        return _c(
          "li",
          { key: index },
          [
            _vm.salesLinks.length > 1
              ? _c("a-icon", {
                  staticClass: "del-links",
                  attrs: { type: "close" },
                  on: {
                    click: function($event) {
                      return _vm.delLinks(index)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "Select",
              {
                attrs: { placeholder: "请选择已添加的小类", clearable: "" },
                on: {
                  "on-change": function(val) {
                    return _vm.linksChange(val, item)
                  }
                },
                model: {
                  value: item.category2Num,
                  callback: function($$v) {
                    _vm.$set(item, "category2Num", $$v)
                  },
                  expression: "item.category2Num"
                }
              },
              _vm._l(_vm.subCategoryList, function(item) {
                return _c(
                  "Option",
                  {
                    key: item.category2Num,
                    attrs: { value: item.category2Num }
                  },
                  [
                    _vm._v(
                      _vm._s(item.category2Name) +
                        " / " +
                        _vm._s(item.category2NameEn)
                    )
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("Input", {
              attrs: { placeholder: "请输入销售链接", clearable: "" },
              model: {
                value: item.marketHref,
                callback: function($$v) {
                  _vm.$set(item, "marketHref", $$v)
                },
                expression: "item.marketHref"
              }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("span", { staticClass: "add-links", on: { click: _vm.addLinks } }, [
      _vm._v("添加更多")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edb3c8e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edb3c8e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/SalesLinks/index.vue
// module id = null
// module chunks = 